import { ResumoFornecedorActionsTypes, type ResumoFornecedorAction } from "./resumoFornecedorActions"
import { ResumoFornecedorInicial, type ResumoFornecedorModel } from "../models/resumoFornecedorModel"

export function resumoFornecedorReducer(
    state: ResumoFornecedorModel,
    action: ResumoFornecedorAction
): ResumoFornecedorModel {
    switch (action.type) {
        case ResumoFornecedorActionsTypes.CARREGAR:
            return {
                ...state,
                possuiDelivery: action.payload.possuiDelivery,
                kpis: action.payload.kpis,
                pontosFaturamento: action.payload.pontosFaturamento,
                pontosExpirado: action.payload.pontosExpirado,
                pontosMes: action.payload.pontosMes,
                pontosMesVendasTipo: action.payload.pontosMesVendasTipo,
                pontosInfoExtras: action.payload.pontosInfoExtras,
                pontosProdutoMaisVendido: action.payload.pontosProdutoMaisVendido,
                melhoresClientes: action.payload.melhoresClientes,
                totalExpirados: action.payload.totalExpirados,
            }
        case ResumoFornecedorActionsTypes.ATUALIZAR_DATAS:
            return {
                ...state,
                dataInicio: action.payload.dataInicio,
                dataFim: action.payload.dataFim,
            }
        default:
            return state
    }
}
